/**
 * Shared document.cookie read/write — previously reimplemented separately in
 * enricher.ts (read-only, regex-based), useActiveService.tsx, and
 * useScreenDetection.tsx (each with slightly different encode/decode and
 * parsing behavior). All current cookie values here are plain identifiers
 * (route paths, breakpoint names) with no characters encodeURIComponent
 * would change, so consolidating onto one encode/decode-safe implementation
 * doesn't alter any of their existing behavior.
 */

export function getCookie(name: string): string | null {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
}

export function setCookie(name: string, value: string, maxAgeDays = 30): void {
    if (typeof document === 'undefined') return;
    const maxAge = maxAgeDays * 24 * 60 * 60;
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; samesite=lax`;
}
